import React from "react";
import PropTypes from "prop-types";
import { NormalSearchBox } from "../../molecules/normal-searchbox";
import CommonListPage from "../../molecules/common-list-page";
import "./search.m.css";

const SearchPage = ({ data = {} }) => {
  return (
    <div styleName="search-container">
      <div className="full-width-with-padding" styleName="search-box">
        <NormalSearchBox />
        <h4 styleName="search-heading">
          Showing {data.total} results for <span styleName="query">{`“${data.query}”`}</span>
        </h4>
      </div>
      <CommonListPage data={data} hideAuthorWithTime={true} />
    </div>
  );
};

SearchPage.propTypes = {
  data: PropTypes.shape({
    query: PropTypes.string,
    total: PropTypes.number,
    stories: PropTypes.array,
    trendingCollection: PropTypes.object
  })
};

export { SearchPage };
